module.exports = __webpack_public_path__ + "img/dialer_sip.64836a71.svg";